import { CxEvent } from '@spartacus/core';

export class Ga4GgReaderTypeEvent extends CxEvent {
  event?: string;
  page_type?: string;
  reader_type?: string;
  visitor_type?: string;
}
